import { render, staticRenderFns } from "./ChoosePicklTypePopup.vue?vue&type=template&id=24147d24&scoped=true&"
import script from "./ChoosePicklTypePopup.vue?vue&type=script&lang=ts&"
export * from "./ChoosePicklTypePopup.vue?vue&type=script&lang=ts&"
import style0 from "./ChoosePicklTypePopup.vue?vue&type=style&index=0&id=24147d24&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24147d24",
  null
  
)

export default component.exports